import { render } from "./IconCasePageActivities.vue?vue&type=template&id=98576552&scoped=true"
const script = {}

import "./IconCasePageActivities.vue?vue&type=style&index=0&id=98576552&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98576552"]])

export default __exports__